import { MessageType_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { SMSSendService, SendRequest } from '@weave/schema-gen-ts/dist/schemas/sms/send/v3/send_service.pb';
import { RelatedType } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaSendV3Service = bindHTTP(SMSSendService);
const DEBUGMODE_AUTOMESSAGE_TOOL_ID = '59906095-ba72-400f-9bf8-883f75c28eb4';

export const sendAutomatedReminder = (
  personPhone: string,
  locationId: string,
  personId: string,
  appointmentId: string
) => {
  const request: SendRequest = {
    locationId: locationId,
    personId: personId,
    autogeneratedBy: DEBUGMODE_AUTOMESSAGE_TOOL_ID,
    personPhone: personPhone,
    body: 'This is a manually triggered automated reminder message.',
    programSlugId: 'manual-messages',
    messageType: MessageType_Enum.APPOINTMENT_REMINDER,
    relatedIds: [
      {
        id: appointmentId,
        type: RelatedType.RELATED_TYPE_APPOINTMENT,
      },
    ],
  };
  SchemaSendV3Service.Send(request);
  console.log('Sent message to', { personPhone, locationId, personId, appointmentId });
};
